import { z } from 'zod';

export const contactSchema = z.object({
  firstName: z
    .string({
      required_error: 'Voornaam is verplicht.',
      invalid_type_error: 'Voornaam moet een tekst zijn.'
    })
    .trim()
    .min(1, 'Voornaam is verplicht.')
    .max(50, 'Voornaam mag maximaal 50 karakters bevatten.'),
  lastName: z
    .string({
      required_error: 'Achternaam is verplicht.',
      invalid_type_error: 'Achternaam moet een tekst zijn.'
    })
    .trim()
    .min(1, 'Achternaam is verplicht.')
    .max(50, 'Achternaam mag maximaal 50 karakters bevatten.'),
  email: z
    .string({
      required_error: 'E-mailadres is verplicht.',
      invalid_type_error: 'E-mailadres moet een tekst zijn.'
    })
    .trim()
    .min(1, 'E-mailadres is verplicht.')
    .email('Voer een geldig e-mailadres in.')
    .max(254, 'E-mailadres mag maximaal 254 karakters bevatten.'),
  message: z
    .string({
      required_error: 'Bericht is verplicht.',
      invalid_type_error: 'Bericht moet een tekst zijn.'
    })
    .trim()
    .min(1, 'Bericht is verplicht.')
    .max(2000, 'Bericht mag maximaal 2000 karakters bevatten.')
});

export type ContactSchema = z.infer<typeof contactSchema>;
